import { ProductVariants } from '../types/theme';

export interface RadiiVariants {
  /** @returns `5px` */
  base: string;
  /** @returns `8px` */
  button: string;
  /** @returns `8px` */
  card: string;
  /** @returns 4px */
  checkbox: string;
  /** @returns `2px` */
  form: string;
  /** @returns `8px` */
  paper: string;
  /** @returns `4px` */
  textOnly: string;
}

export type RadiiVariantsType = 'base' | 'button' | 'card' | 'checkbox' | 'form' | 'paper' | 'textOnly';

export type Radii = RadiiVariants & ProductVariants<RadiiVariants>;

const base: RadiiVariants = {
  base: '5px',
  button: '8px',
  card: '8px',
  checkbox: '4px',
  form: '2px',
  paper: '8px',
  textOnly: '4px'
};

const radii: Radii = {
  ...base,
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export const radiiVariants = Object.keys(base) as RadiiVariantsType[];

export default radii;
